export default __webpack_public_path__ + "static/from-abroad-banner-12dcbc438e167e3838e2fcee3e5073de.jpg";